
// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import {
//   FaAsterisk, FaBriefcase, FaBuilding, FaCalendarAlt, FaCheck, FaDownload, FaEdit,
//   FaEye, FaSave, FaSearch, FaShieldAlt, FaSignOutAlt, FaSpinner, FaSync, FaTimes,
//   FaUser, FaUserTie
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import JSZip from "jszip";
// import { saveAs } from "file-saver";
// import "../index.css";
// import "./EmployeeDashboard.css";
// import "./EmployeeLeaves.css";

// const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

// const MetaRow = ({ label, value, icon }) => (
//   <div className="flex items-start gap-3">
//     {icon && <div className="mt-1 text-blue-500 scale-110">{icon}</div>}
//     <div>
//       <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
//       <p className="text-sm font-bold text-gray-800">{value || "---"}</p>
//     </div>
//   </div>
// );

// const StatusBadge = ({ status, className = "" }) => {
//   const badges = {
//     approved: "bg-emerald-50 text-emerald-700 border-emerald-100 shadow-sm",
//     rejected: "bg-rose-50 text-rose-700 border-rose-100 shadow-sm",
//     uploaded: "bg-blue-50 text-blue-700 border-blue-100 shadow-sm",
//     missing: "bg-gray-50 text-gray-400 border-gray-100 shadow-sm"
//   };

//   return (
//     <span className={`inline-flex items-center px-3 py-1.5 rounded-lg text-[9px] font-bold uppercase tracking-widest border transition-all duration-300 ${badges[status] || badges.missing} ${className}`}>
//       {status === 'approved' && <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-2 shadow-[0_0_8px_rgba(16,185,129,0.5)]"></div>}
//       {status === 'rejected' && <div className="w-1.5 h-1.5 bg-rose-500 rounded-full mr-2 shadow-[0_0_8px_rgba(244,63,94,0.5)]"></div>}
//       {status === 'uploaded' && <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2 shadow-[0_0_8px_rgba(59,130,246,0.5)]"></div>}
//       {status === 'missing' && <div className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-2"></div>}
//       {status}
//     </span>
//   );
// };

// export default function PersonalDocuments() {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [dateFilter, setDateFilter] = useState("");
//   const [roleFilter, setRoleFilter] = useState("");
//   const [roles, setRoles] = useState([]);
//   const [roleSearchQuery, setRoleSearchQuery] = useState("");
//   const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//   const roleDropdownRef = useRef(null);

//   const [marks, setMarks] = useState({});

//   // Pagination states
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalCount: 0,
//     limit: 10,
//   });

//   // Editing states
//   const [isEditingBank, setIsEditingBank] = useState(false);
//   const [bankForm, setBankForm] = useState({ bankName: "", accountNumber: "", ifscCode: "" });
//   const [isSavingBank, setIsSavingBank] = useState(false);

//   const [isEditingEmergency1, setIsEditingEmergency1] = useState(false);
//   const [emergency1Form, setEmergency1Form] = useState({ name: "", phone: "", relationship: "" });
//   const [isSavingE1, setIsSavingE1] = useState(false);

//   const [isEditingEmergency2, setIsEditingEmergency2] = useState(false);
//   const [emergency2Form, setEmergency2Form] = useState({ name: "", phone: "", relationship: "" });
//   const [isSavingE2, setIsSavingE2] = useState(false);
//   const [isDownloadingBulk, setIsDownloadingBulk] = useState(false);

//   // Get clientId from localStorage
//   const getClientId = () => {
//     return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
//   };

//   // Helper to get filtered data
//   const getFilteredData = () => {
//     if (!Array.isArray(data)) return [];

//     return data.filter(row => {
//       const docs = row.documents || {};
//       const hasUploadedDocs = Object.entries(docs).some(([key, doc]) =>
//         !['bankDetails', 'emergencyContact1', 'emergencyContact2', '_id'].includes(key) &&
//         doc && typeof doc === 'object' && doc.filePath
//       );

//       const candidateObj = row.candidateId && typeof row.candidateId === 'object' ? row.candidateId : null;
//       const candName = candidateObj?.name || row.candidateName || row.name || '';
//       const candEmail = candidateObj?.email || row.email || '';
//       const query = searchQuery.toLowerCase();

//       const matchesSearch = candName.toLowerCase().includes(query) || candEmail.toLowerCase().includes(query);

//       const matchesDate = dateFilter
//         ? new Date(row.createdAt || row.updatedAt).toISOString().slice(0, 10) === dateFilter
//         : true;

//       const candRole = candidateObj?.jobId?.role || row.jobId?.role || row.role || "";
//       const matchesRole = roleFilter ? candRole === roleFilter : true;

//       return matchesSearch && hasUploadedDocs && matchesDate && matchesRole;
//     });
//   };

//   useEffect(() => {
//     fetchData();
//     fetchRoles();

//     const handleClickOutside = (event) => {
//       if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//         setIsRoleDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Update pagination when filtered data changes
//   useEffect(() => {
//     if (Array.isArray(data)) {
//       const filtered = getFilteredData();
//       setPagination(prev => ({
//         ...prev,
//         totalCount: filtered.length,
//         totalPages: Math.ceil(filtered.length / prev.limit),
//         currentPage: 1
//       }));
//     }
//   }, [data, searchQuery, roleFilter, dateFilter]);

//   const fetchRoles = async () => {
//     try {
//       const clientId = getClientId();
//       const res = await axios.get(`${API_BASE_URL}/jobs/all/${clientId}`);
//       if (res.data.success) {
//         const jobData = res.data.jobPosts || res.data.data || [];
//         const roleNames = Array.from(new Set(jobData.map(job => job.role))).filter(Boolean);
//         const uniqueRoles = roleNames.map((name, index) => ({ _id: index, name }));
//         setRoles(uniqueRoles);
//       }
//     } catch (err) {
//       console.error("Failed to fetch roles:", err);
//     }
//   };

//   const getQueryUserId = () => {
//     const params = new URLSearchParams(window.location.search);
//     return params.get("userId");
//   };

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const clientId = getClientId();
//       const userId = getQueryUserId();
//       const token = localStorage.getItem("candidateToken");
//       const headers = token ? { Authorization: `Bearer ${token}` } : {};

//       if (userId) {
//         // Fetch single candidate documents
//         const res = await axios.get(`${API_BASE_URL}/candidate/admin/${userId}?clientId=${clientId}`, { headers });
//         if (res.data) {
//           const payload = res.data.success ? res.data.data : res.data;
//           setData(payload);
//         }
//       } else {
//         // Fetch all candidates documents - NEW API: /candidate/all-documents/:clientId
//         const res = await axios.get(`${API_BASE_URL}/candidate/all-documents/${clientId}`, { headers });
//         if (res.data && res.data.success && Array.isArray(res.data.data)) {
//           setData(res.data.data);
//         } else if (res.data && Array.isArray(res.data)) {
//           setData(res.data);
//         } else {
//           setData([]);
//         }
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message || "Failed to load documents");
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initialize forms when data is loaded
//   useEffect(() => {
//     if (data && !Array.isArray(data)) {
//       setBankForm({
//         bankName: data.documents?.bankDetails?.bankName || "",
//         accountNumber: data.documents?.bankDetails?.accountNumber || "",
//         ifscCode: data.documents?.bankDetails?.ifscCode || ""
//       });
//       setEmergency1Form({
//         name: data.documents?.emergencyContact1?.name || "",
//         phone: data.documents?.emergencyContact1?.phone || "",
//         relationship: data.documents?.emergencyContact1?.relationship || ""
//       });
//       setEmergency2Form({
//         name: data.documents?.emergencyContact2?.name || "",
//         phone: data.documents?.emergencyContact2?.phone || "",
//         relationship: data.documents?.emergencyContact2?.relationship || ""
//       });
//     }
//   }, [data]);

//   const handleSaveBankDetails = async () => {
//     if (!bankForm.bankName || !bankForm.accountNumber || !bankForm.ifscCode) {
//       return toast.warning("Please fill all bank details");
//     }
//     setIsSavingBank(true);
//     try {
//       const token = localStorage.getItem("candidateToken");
//       const clientId = getClientId();
//       const res = await axios.post(`${API_BASE_URL}/candidate/save-bank-details`,
//         { bankDetails: bankForm, clientId },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (res.data.success) {
//         toast.success("Bank details updated");
//         setIsEditingBank(false);
//         fetchData();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to save bank details");
//     } finally {
//       setIsSavingBank(false);
//     }
//   };

//   const handleSaveEmergencyContact = async (num) => {
//     const form = num === 1 ? emergency1Form : emergency2Form;
//     if (!form.name || !form.phone || !form.relationship) {
//       return toast.warning(`Please fill all fields for Emergency Contact #${num}`);
//     }
//     num === 1 ? setIsSavingE1(true) : setIsSavingE2(true);
//     try {
//       const token = localStorage.getItem("candidateToken");
//       const clientId = getClientId();
//       const res = await axios.post(`${API_BASE_URL}/candidate/save-emergency-contact`,
//         { contactNumber: num, contact: form, clientId },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       if (res.data.success) {
//         toast.success(`Emergency Contact #${num} updated`);
//         num === 1 ? setIsEditingEmergency1(false) : setIsEditingEmergency2(false);
//         fetchData();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to save contact");
//     } finally {
//       num === 1 ? setIsSavingE1(false) : setIsSavingE2(false);
//     }
//   };

//   const openFile = (filePath) => {
//     if (!filePath) return;
//     // If it's already a full URL
//     if (filePath.startsWith('http')) {
//       window.open(filePath, "_blank");
//       return;
//     }
//     const baseUrl = API_BASE_URL.replace("/api", "");
//     const relativePath = filePath.includes("uploads")
//       ? "uploads/" + filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
//       : filePath.replace(/\\/g, "/");
//     const url = `${baseUrl}/${relativePath}`;
//     window.open(url, "_blank");
//   };

//   const mark = (key, state) => {
//     setMarks((s) => ({ ...s, [key]: state }));
//     toast.success(`${state === "approved" ? "Approved" : "Rejected"}: ${key}`);
//   };

//   const handleBulkDownload = async (targetData = null) => {
//     const activeData = targetData || data;
//     if (!activeData || Array.isArray(activeData)) return;

//     const docsToDownload = Object.entries(activeData.documents || {})
//       .filter(([key, doc]) =>
//         !['bankDetails', 'emergencyContact1', 'emergencyContact2', '_id'].includes(key) &&
//         doc && typeof doc === 'object' && doc.filePath
//       );

//     if (docsToDownload.length === 0) {
//       return toast.info("No documents uploaded to download");
//     }

//     setIsDownloadingBulk(true);
//     const zip = new JSZip();
//     const toastId = toast.loading(`Preparing bulk download for ${activeData.candidateName || 'Candidate'}...`);

//     try {
//       const baseUrl = API_BASE_URL.replace("/api", "");
//       const downloadPromises = docsToDownload.map(async ([key, doc]) => {
//         let url;
//         if (doc.filePath.startsWith('http')) {
//           url = doc.filePath;
//         } else {
//           const relativePath = doc.filePath.includes("uploads")
//             ? "uploads/" + doc.filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
//             : doc.filePath.replace(/\\/g, "/");
//           url = `${baseUrl}/${relativePath}`;
//         }

//         try {
//           const response = await axios.get(url, { responseType: 'arraybuffer' });
//           const fileName = doc.fileName || `${key}.${doc.filePath.split('.').pop()}`;
//           zip.file(fileName, response.data);
//         } catch (err) {
//           console.error(`Failed to download ${key}:`, err);
//         }
//       });

//       await Promise.all(downloadPromises);

//       const content = await zip.generateAsync({ type: "blob" });
//       saveAs(content, `${activeData.candidateName || 'Candidate'}_Documents.zip`);
//       toast.update(toastId, { render: "Bulk download complete!", type: "success", isLoading: false, autoClose: 3000 });
//     } catch (err) {
//       console.error("Bulk download failed:", err);
//       toast.update(toastId, { render: "Bulk download failed", type: "error", isLoading: false, autoClose: 3000 });
//     } finally {
//       setIsDownloadingBulk(false);
//     }
//   };

//   // Pagination Handlers
//   const handleItemsPerPageChange = (limit) => {
//     const filtered = Array.isArray(data) ? getFilteredData() : [];
//     setPagination({
//       currentPage: 1,
//       limit: limit,
//       totalCount: filtered.length,
//       totalPages: Math.ceil(filtered.length / limit)
//     });
//   };

//   const handlePrevPage = () => {
//     if (pagination.currentPage > 1) {
//       setPagination(prev => ({
//         ...prev,
//         currentPage: prev.currentPage - 1
//       }));
//     }
//   };

//   const handleNextPage = () => {
//     if (pagination.currentPage < pagination.totalPages) {
//       setPagination(prev => ({
//         ...prev,
//         currentPage: prev.currentPage + 1
//       }));
//     }
//   };

//   const handlePageClick = (page) => {
//     setPagination(prev => ({
//       ...prev,
//       currentPage: page
//     }));
//   };

//   const getPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= pagination.totalPages; i++) {
//       if (
//         i === 1 ||
//         i === pagination.totalPages ||
//         (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
//       ) {
//         pageNumbers.push(i);
//       } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
//         pageNumbers.push("...");
//       }
//     }
//     return pageNumbers;
//   };

//   const resetFilters = () => {
//     setSearchQuery("");
//     setRoleFilter("");
//     setDateFilter("");
//     setRoleSearchQuery("");
//   };

//   if (loading)
//     return (
//       <div className="admin-dash">
//         <div className="admin-dash__loading">
//           <div className="admin-dash__spinner" />
//           <p className="admin-dash__loading-text">Loading documents…</p>
//         </div>
//       </div>
//     );

//   if (Array.isArray(data) && data.length === 0 && !loading) return (
//     <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
//       <div className="bg-white rounded-lg p-8 shadow-md text-center max-w-sm w-full border border-gray-100">
//         <FaUser size={32} className="mx-auto text-gray-300 mb-4" />
//         <h2 className="text-xl font-bold text-gray-800 mb-2">No Documents Found</h2>
//         <p className="text-sm text-gray-500 mb-6">No candidate documents available.</p>
//         <button onClick={fetchData} className="w-full py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors">Retry</button>
//       </div>
//     </div>
//   );

//   if (!data && !loading) return (
//     <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
//       <div className="bg-white rounded-lg p-8 shadow-md text-center max-w-sm w-full border border-gray-100">
//         <FaUser size={32} className="mx-auto text-gray-300 mb-4" />
//         <h2 className="text-xl font-bold text-gray-800 mb-2">Unavailable</h2>
//         <p className="text-sm text-gray-500 mb-6">Candidate profile not found.</p>
//         <button onClick={fetchData} className="w-full py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors">Retry</button>
//       </div>
//     </div>
//   );

//   // Admin List View
//   if (Array.isArray(data)) {
//     const filteredData = getFilteredData();

//     const indexOfLastItem = pagination.currentPage * pagination.limit;
//     const indexOfFirstItem = indexOfLastItem - pagination.limit;
//     const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//     return (
//       <div style={{backgroundColor:'white'}} className="emp-dash">
//         <main className="p-4 sm:p-6 lg:p-8">

//           {/* Dashboard Header */}
//           <div className="emp-dash__header">
//             <div>
//               <h1 className="emp-dash__greeting">
//                 Personal <span>Documents</span>
//               </h1>
//               <p className="emp-dash__subtitle">
//                 Review and manage candidate personal documents.
//               </p>
//             </div>
//             <div className="emp-dash__date-pill">
//               <FaShieldAlt />
//               <span>
//                 {new Date().toLocaleDateString("en-US", {
//                   weekday: "short",
//                   year: "numeric",
//                   month: "short",
//                   day: "numeric",
//                 })}
//               </span>
//             </div>
//           </div>

//           {/* Filters Section */}
//           <div className="emp-dash__card mb-6">
//             <div className="emp-dash__card-header">
//               <div>
//                 <h3 className="emp-dash__card-title flex items-center gap-2">
//                   <FaSearch className="text-blue-600" /> Filter Documents
//                 </h3>
//                 <p className="emp-dash__card-desc">Search by name, email or role</p>
//               </div>
//             </div>
//             <div className="emp-dash__card-body bg-gray-50/50">
//               <div className="flex flex-wrap items-center gap-2">

//                 {/* Search Bar */}
//                 <div className="relative flex-1 min-w-[180px]">
//                   <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//                   <input
//                     type="text"
//                     placeholder="Search by name or email..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                     className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//                   />
//                 </div>

//                 {/* Role Filter Button */}
//                 <div className="relative" ref={roleDropdownRef}>
//                   <button
//                     onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//                     className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                       roleFilter
//                         ? 'bg-blue-600 text-white hover:bg-blue-700'
//                         : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                     }`}
//                   >
//                     <FaBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
//                   </button>

//                   {/* Role Filter Dropdown */}
//                   {isRoleDropdownOpen && (
//                     <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                       <div className="p-2 border-b border-gray-100 bg-gray-50">
//                         <div className="relative">
//                           <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                           <input
//                             type="text"
//                             className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                             placeholder="Search roles..."
//                             value={roleSearchQuery}
//                             onChange={(e) => setRoleSearchQuery(e.target.value)}
//                             onClick={(e) => e.stopPropagation()}
//                             autoFocus
//                           />
//                         </div>
//                       </div>
//                       <div
//                         onClick={() => { setRoleFilter(''); setIsRoleDropdownOpen(false); setRoleSearchQuery(''); }}
//                         className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
//                           !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                         }`}
//                       >
//                         All Roles
//                       </div>
//                       {roles
//                         .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                         .map((r) => (
//                           <div
//                             key={r._id}
//                             onClick={() => { setRoleFilter(r.name); setIsRoleDropdownOpen(false); setRoleSearchQuery(''); }}
//                             className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
//                               roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                             }`}
//                           >
//                             {r.name}
//                           </div>
//                         ))}
//                       {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
//                         <div className="px-3 py-2 text-xs text-gray-400 text-center">No roles found</div>
//                       )}
//                     </div>
//                   )}
//                 </div>

//                 {/* Date Filter */}
//                 <div className="relative">
//                   <button
//                     onClick={(e) => {
//                       const dateInput = e.currentTarget.nextElementSibling;
//                       if (dateInput && dateInput.showPicker) {
//                         dateInput.showPicker();
//                       } else {
//                         dateInput?.focus();
//                       }
//                     }}
//                     className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                       dateFilter
//                         ? 'bg-blue-600 text-white hover:bg-blue-700'
//                         : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//                     }`}
//                   >
//                     <FaCalendarAlt className="text-xs" /> {dateFilter ? new Date(dateFilter).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Date'}
//                   </button>
//                   <input
//                     type="date"
//                     value={dateFilter}
//                     onChange={(e) => setDateFilter(e.target.value)}
//                     className="absolute opacity-0 pointer-events-none"
//                     style={{ width: 0, height: 0 }}
//                   />
//                 </div>

//                 {/* Refresh Button */}
//                 <button
//                   onClick={fetchData}
//                   className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition flex items-center gap-1"
//                   title="Refresh"
//                 >
//                   <FaSync className={loading ? 'animate-spin' : ''} size={11} />
//                 </button>

//                 {/* Clear Filters Button */}
//                 {(searchQuery || roleFilter || dateFilter) && (
//                   <button
//                     onClick={resetFilters}
//                     className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
//                   >
//                     Clear
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Documents Table */}
//           <div className="emp-dash__card mb-6">
//             {loading ? (
//               <div className="py-10 text-center">
//                 <div className="flex flex-col items-center justify-center gap-3">
//                   <div className="emp-dash__spinner"></div>
//                   <span className="text-sm font-medium text-gray-500">Loading documents...</span>
//                 </div>
//               </div>
//             ) : filteredData.length > 0 ? (
//               <div className="emp-dash__table-wrap">
//                 <table className="emp-dash__table">
//                   <thead>
//                     <tr>
//                       <th>Candidate</th>
//                       {["Aadhar", "PAN", "Photo", "10th", "12th", "Grad", "Exp", "Bank"].map(h => (
//                         <th key={h}>{h}</th>
//                       ))}
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.map((row) => {
//                       const docs = row.documents || {};
//                       const candidateObj = row.candidateId && typeof row.candidateId === 'object' ? row.candidateId : null;
//                       const candName = candidateObj?.name || row.candidateName || row.name || 'Unknown';
//                       const candEmail = candidateObj?.email || row.email || '';
//                       const candId = candidateObj?._id || candidateObj?.id || row.candidateId || row._id || '-';

//                       const renderDocMini = (docKey) => {
//                         const doc = docs[docKey] || {};
//                         const uploaded = !!doc.filePath;
//                         return (
//                           <td key={docKey} className="px-2 py-2 text-center">
//                             <div className="flex items-center justify-center gap-1">
//                               {uploaded ? (
//                                 <>
//                                   <button
//                                     onClick={() => openFile(doc.filePath)}
//                                     className="text-blue-500 hover:text-blue-700"
//                                     title="View"
//                                   >
//                                     <FaEye size={13} />
//                                   </button>
//                                   <button
//                                     onClick={() => openFile(doc.filePath)}
//                                     className="text-gray-400 hover:text-gray-700"
//                                     title="Download"
//                                   >
//                                     <FaDownload size={13} />
//                                   </button>
//                                 </>
//                               ) : (
//                                 <FaTimes className="text-gray-200 mx-auto" size={11} />
//                               )}
//                             </div>
//                           </td>
//                         );
//                       };

//                       return (
//                         <tr key={candId} className="border-b hover:bg-gray-50 transition-colors">
//                           <td className="px-2 py-2">
//                             <div className="flex items-center gap-2">
//                               <div className="w-7 h-7 rounded-full bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm flex-shrink-0">
//                                 {candName.charAt(0)}
//                               </div>
//                               <div className="text-left">
//                                 <div className="text-gray-900 whitespace-nowrap text-xs font-medium">{candName}</div>
//                                 <div className="text-[10px] text-gray-400">{candEmail || String(candId).slice(-8)}</div>
//                               </div>
//                             </div>
//                           </td>
//                           {renderDocMini('aadharCard')}
//                           {renderDocMini('panCard')}
//                           {renderDocMini('passportPhoto')}
//                           {renderDocMini('tenthCertificate')}
//                           {renderDocMini('twelfthCertificate')}
//                           {renderDocMini('graduationCertificate')}
//                           {renderDocMini('experienceLetters')}
//                           <td className="px-2 py-2 text-center">
//                             <div className={`w-2 h-2 mx-auto rounded-full ${docs.bankDetails?.bankName ? 'bg-emerald-500' : 'bg-gray-200'}`}></div>
//                           </td>
//                           <td className="px-2 py-2 text-center">
//                             <div className="flex justify-center gap-2">
//                               <button
//                                 onClick={() => window.location.assign(`/personal-documents?userId=${candId}`)}
//                                 className="text-blue-500 hover:text-blue-700"
//                                 title="Review Documents"
//                               >
//                                 <FaEye size={14} />
//                               </button>
//                               <button
//                                 onClick={() => handleBulkDownload(row)}
//                                 disabled={isDownloadingBulk}
//                                 className="text-emerald-500 hover:text-emerald-700 disabled:opacity-50"
//                                 title="Download All"
//                               >
//                                 <FaDownload size={14} />
//                               </button>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>

//                 {/* Pagination */}
//                 {filteredData.length > 0 && (
//                   <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
//                     {/* Left Side - Showing Info + Select */}
//                     <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
//                       <span>Showing</span>
//                       <span className="font-medium">{indexOfFirstItem + 1}</span>
//                       <span>to</span>
//                       <span className="font-medium">{Math.min(indexOfLastItem, filteredData.length)}</span>
//                       <span>of</span>
//                       <span className="font-medium">{filteredData.length}</span>
//                       <span>results</span>
//                       <select
//                         value={pagination.limit}
//                         onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
//                         className="p-1 ml-2 text-sm border rounded-lg"
//                       >
//                         <option value={5}>5</option>
//                         <option value={10}>10</option>
//                         <option value={20}>20</option>
//                         <option value={50}>50</option>
//                       </select>
//                     </div>

//                     {/* Pagination buttons */}
//                     <div className="flex items-center gap-2 mt-2 sm:mt-0">
//                       <button
//                         onClick={handlePrevPage}
//                         disabled={pagination.currentPage === 1}
//                         className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
//                           pagination.currentPage === 1
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//                         }`}
//                       >
//                         Previous
//                       </button>

//                       <div className="flex items-center gap-1">
//                         {getPageNumbers().map((page, index) => (
//                           <button
//                             key={index}
//                             onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
//                             disabled={page === "..."}
//                             className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
//                               page === "..."
//                                 ? "text-gray-500 cursor-default"
//                                 : pagination.currentPage === page
//                                 ? "bg-blue-600 text-white"
//                                 : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
//                             }`}
//                           >
//                             {page}
//                           </button>
//                         ))}
//                       </div>

//                       <button
//                         onClick={handleNextPage}
//                         disabled={pagination.currentPage === pagination.totalPages}
//                         className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
//                           pagination.currentPage === pagination.totalPages
//                             ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                             : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
//                         }`}
//                       >
//                         Next
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <div className="text-center py-20">
//                 <div className="bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                   <FaSearch className="text-2xl text-gray-200" />
//                 </div>
//                 <h2 className="text-lg font-bold text-gray-800">No records found</h2>
//                 <p className="text-xs text-gray-400 mt-1">Try refined search parameters</p>
//               </div>
//             )}
//           </div>

//         </main>
//       </div>
//     );
//   }

//   // Profile Specific View (single candidate)
//   const docKeys = Object.keys(data.documents || {}).filter(key =>
//     !['bankDetails', 'emergencyContact1', 'emergencyContact2', '_id'].includes(key)
//   );

//   return (
//     <div className="w-full min-h-screen p-2 bg-slate-50/50">
//       <div className="max-w-[1600px] mx-auto space-y-3">
        
//         {/* Corporate Sleek Header */}
//         <div className="relative overflow-hidden bg-gradient-to-r from-green-600 to-blue-700 rounded-3xl p-6 shadow-xl border border-white/10 group">
//           <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent"></div>
          
//           <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
//             <div className="flex items-center gap-5">
//               <div className="relative">
//                 <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-blue-600 text-2xl font-bold shadow-2xl ring-4 ring-white/20 group-hover:scale-105 transition-transform duration-500 bg-white">
//                   {data.candidateName?.charAt(0) || data.candidateId?.name?.charAt(0) || <FaUser />}
//                 </div>
//                 <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-emerald-500 rounded-lg border-2 border-white flex items-center justify-center text-white shadow-lg">
//                   <FaCheck size={10} />
//                 </div>
//               </div>
              
//               <div className="text-center md:text-left">
//                 <h1 className="text-xl font-bold text-white tracking-tight drop-shadow-sm">
//                   {data.candidateName || data.candidateId?.name || 'Review Profile'}
//                 </h1>
//                 <p className="text-white/90 text-[9px] font-bold uppercase tracking-[0.15em] mt-1.5 flex items-center justify-center md:justify-start gap-1.5 bg-white/10 backdrop-blur-md px-2.5 py-0.5 rounded-lg w-fit border border-white/10">
//                   <FaUserTie size={10} className="text-emerald-400" /> IDENTITY VERIFICATION RECORD
//                 </p>
//                 <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mt-3">
//                   <span className="px-3 py-1 bg-white/10 backdrop-blur-md text-blue-100 text-[9px] font-bold uppercase tracking-wider rounded-lg border border-white/10">
//                     UID: {data._id?.slice(-8).toUpperCase()}
//                   </span>
//                   <span className="px-3 py-1 bg-white/10 backdrop-blur-md text-emerald-100 text-[9px] font-bold uppercase tracking-wider rounded-lg border border-white/10 flex items-center gap-1.5">
//                     <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></div>
//                     VERIFIED
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-center gap-3">
//               <button
//                 onClick={() => handleBulkDownload()}
//                 disabled={isDownloadingBulk}
//                 className="h-10 px-6 bg-white/20 hover:bg-white text-white hover:text-blue-600 rounded-xl font-bold text-[10px] uppercase tracking-widest flex items-center gap-3 transition-all border border-white/10 active:scale-95 disabled:opacity-50"
//               >
//                 {isDownloadingBulk ? <FaSpinner className="animate-spin" size={12} /> : <FaDownload size={12} />}
//                 {isDownloadingBulk ? "GENERATING..." : "DOWNLOAD VAULT"}
//               </button>
//               <button
//                 onClick={() => window.location.assign('/personal-documents')}
//                 className="h-10 px-6 bg-white text-blue-600 hover:bg-gray-50 rounded-xl font-bold text-[10px] uppercase tracking-widest shadow-xl transition-all active:scale-95 flex items-center gap-3"
//               >
//                 <FaSignOutAlt size={12} />
//                 BACK TO INDEX
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Main Review Dashboard */}
//         <div className="flex flex-col gap-3 pb-8">
          
//           {/* Documents Table View */}
//           <div className="w-full space-y-3">
//             <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
//               <div className="p-4 bg-gray-50/50 border-b border-gray-100 flex items-center justify-between">
//                  <div className="flex items-center gap-2">
//                     <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shadow-inner border border-blue-100"><FaBriefcase size={14}/></div>
//                     <h3 className="text-xs font-bold text-gray-800 uppercase tracking-widest font-sans">Primary Credentials</h3>
//                  </div>
//                  <div className="flex items-center gap-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest bg-white px-4 py-1.5 rounded-full border border-gray-100">
//                     <div className="w-2 h-2 bg-emerald-500 rounded-full"></div> Approved
//                     <div className="w-2 h-2 bg-blue-500 rounded-full"></div> Uploaded
//                     <div className="w-2 h-2 bg-gray-300 rounded-full"></div> Missing
//                  </div>
//               </div>

//               <div className="overflow-x-auto">
//                 <table className="w-full text-left">
//                   <thead className="bg-gradient-to-r from-green-500 to-blue-600 text-[11px] font-bold text-white uppercase tracking-widest border-b border-blue-100">
//                     <tr>
//                       <th className="px-6 py-5">Asset Identification</th>
//                       <th className="px-6 py-5 text-center">Status</th>
//                       <th className="px-6 py-5 text-center">Reference</th>
//                       <th className="px-6 py-5 text-right">Verification Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-50 border-t border-gray-100">
//                     {docKeys.map((key) => {
//                       const doc = data.documents[key] || {};
//                       const uploaded = !!doc.filePath;
//                       const state = marks[key] || (doc.verified ? 'approved' : uploaded ? 'uploaded' : 'missing');

//                       return (
//                         <tr key={key} className="group hover:bg-slate-50 transition-all duration-300">
//                           <td className="px-6 py-4">
//                              <div className="flex items-center gap-4">
//                                 <div className={`w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-500 ${uploaded ? 'bg-blue-50 text-blue-600 shadow-inner group-hover:bg-blue-600 group-hover:text-white' : 'bg-gray-50 text-gray-300 border border-gray-100'}`}>
//                                    <FaBriefcase size={18} />
//                                 </div>
//                                  <div>
//                                     <p className="text-xs font-bold text-gray-900 uppercase tracking-tight group-hover:text-blue-600 transition-colors">{key.replace(/([A-Z])/g, ' $1')}</p>
//                                     <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">{uploaded ? 'Synchronized Archive' : 'Awaiting Manifest'}</p>
//                                  </div>
//                              </div>
//                            </td>
//                           <td className="px-6 py-4 text-center">
//                             <StatusBadge status={state} />
//                            </td>
//                           <td className="px-6 py-4 text-center font-mono text-[10px] text-gray-400 font-bold uppercase tracking-tighter">
//                             {doc.fileName ? `...${doc.fileName.slice(-15)}` : '--'}
//                            </td>
//                           <td className="px-6 py-4">
//                             <div className="flex items-center justify-end gap-2 outline-none">
//                                <button
//                                   onClick={() => openFile(doc.filePath)}
//                                   disabled={!uploaded}
//                                   className={`h-11 px-5 rounded-xl transition-all flex items-center gap-2 active:scale-95 ${uploaded ? 'bg-gradient-to-r from-green-500 to-blue-600 text-white hover:from-green-600 hover:to-blue-700 shadow-md shadow-blue-100' : 'bg-gray-100 text-gray-400 cursor-not-allowed opacity-50'}`}
//                                >
//                                   <FaEye size={18} />
//                                   <span className="text-[11px] font-bold uppercase tracking-widest">{uploaded ? '' : 'Locked'}</span>
//                                </button>
//                                <div className="h-6 w-px bg-gray-200 mx-1"></div>
//                                <button
//                                  onClick={() => mark(key, 'approved')}
//                                  className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all border-2 ${state === 'approved' ? 'bg-emerald-500 border-emerald-500 text-white shadow-lg shadow-emerald-200' : 'border-emerald-100 bg-emerald-50 text-emerald-600 hover:bg-emerald-500 hover:text-white hover:border-emerald-500 shadow-sm'}`}
//                                  title="Approve"
//                                >
//                                  <FaCheck size={24} />
//                                </button>
//                                <button
//                                  onClick={() => mark(key, 'rejected')}
//                                  className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all border-2 ${state === 'rejected' ? 'bg-rose-500 border-rose-500 text-white shadow-lg shadow-rose-200' : 'border-rose-100 bg-rose-50 text-rose-600 hover:bg-rose-500 hover:text-white hover:border-rose-500 shadow-sm'}`}
//                                  title="Reject"
//                                >
//                                  <FaTimes size={24} />
//                                </button>
//                             </div>
//                            </td>
//                           </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>

//           {/* Details Row - Three Cards Side by Side */}
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
            
//              {/* Bank Card */}
//              <div className="bg-white rounded-2xl shadow-lg border-t-4 border-blue-500 overflow-hidden group hover:shadow-xl transition-all duration-500">
//                <div className="p-5 bg-gray-50 flex items-center justify-between border-b border-gray-100">
//                    <div className="flex items-center gap-3 text-gray-800">
//                       <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shadow-inner border border-blue-100">
//                          <FaBuilding size={14} />
//                       </div>
//                       <h3 className="text-xs font-bold uppercase tracking-widest">Banking Profile</h3>
//                    </div>
//                    {!isEditingBank && (
//                     <button 
//                       onClick={() => setIsEditingBank(true)} 
//                       className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-blue-600 border border-blue-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-blue-50 transition-all shadow-sm active:scale-95"
//                     >
//                       <FaEdit size={14} />
//                       <span>EDIT</span>
//                     </button>
//                   )}
//                </div>
               
//                <div className="p-4 space-y-3">
//                   {isEditingBank ? (
//                     <div className="space-y-3">
//                         <input value={bankForm.bankName} onChange={e => setBankForm({...bankForm, bankName: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none focus:ring-1 focus:ring-blue-500" placeholder="Bank Name" />
//                         <input value={bankForm.accountNumber} onChange={e => setBankForm({...bankForm, accountNumber: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold font-mono outline-none focus:ring-1 focus:ring-blue-500" placeholder="A/C Number" />
//                          <div className="flex gap-2">
//                             <button onClick={handleSaveBankDetails} className="flex-1 h-10 bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-blue-100 active:scale-95 transition-all">Save</button>
//                             <button onClick={() => setIsEditingBank(false)} className="px-6 h-10 bg-gray-50 text-gray-400 border border-gray-100 rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-gray-100 transition-all">Cancel</button>
//                          </div>
//                     </div>
//                   ) : (
//                      <div className="space-y-2">
//                         <MetaRow icon={<FaBuilding className="text-blue-500" />} label="Financial Institution" value={data.documents?.bankDetails?.bankName} />
//                         <MetaRow icon={<FaBuilding className="text-blue-500" />} label="Account Repository" value={data.documents?.bankDetails?.accountNumber} />
//                         <MetaRow icon={<FaBuilding className="text-blue-500" />} label="Transit Code (IFSC)" value={data.documents?.bankDetails?.ifscCode} />
//                      </div>
//                   )}
//                </div>
//             </div>

//             {/* Emergency #1 Card */}
//             <div className="bg-white rounded-2xl shadow-lg border-t-4 border-emerald-500 overflow-hidden group hover:shadow-xl transition-all duration-500">
//                <div className="p-5 bg-gray-50 flex items-center justify-between border-b border-gray-100">
//                   <div className="flex items-center gap-3 text-gray-800">
//                      <div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-inner border border-emerald-100">
//                         <FaAsterisk size={14} />
//                      </div>
//                      <h3 className="text-xs font-bold uppercase tracking-widest">Emergency #1</h3>
//                   </div>
//                    {!isEditingEmergency1 && (
//                     <button 
//                       onClick={() => setIsEditingEmergency1(true)} 
//                       className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-emerald-600 border border-emerald-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-emerald-50 transition-all shadow-sm active:scale-95"
//                     >
//                       <FaEdit size={14} />
//                       <span>EDIT</span>
//                     </button>
//                   )}
//                </div>
//                <div className="p-4">
//                   {isEditingEmergency1 ? (
//                     <div className="space-y-3">
//                         <input value={emergency1Form.name} onChange={e => setEmergency1Form({...emergency1Form, name: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Name" />
//                         <input value={emergency1Form.phone} onChange={e => setEmergency1Form({...emergency1Form, phone: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Phone" />
//                         <div className="flex gap-2">
//                             <button onClick={() => handleSaveEmergencyContact(1)} className="flex-1 h-10 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-emerald-100 active:scale-95 transition-all">Save</button>
//                             <button onClick={() => setIsEditingEmergency1(false)} className="px-6 h-10 bg-gray-50 text-gray-400 border border-gray-100 rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-gray-100 transition-all">Cancel</button>
//                          </div>
//                     </div>
//                   ) : (
//                     <div className="space-y-2">
//                        <MetaRow icon={<FaUser className="text-emerald-500" />} label="Identity" value={data.documents?.emergencyContact1?.name} />
//                        <MetaRow icon={<FaBuilding className="text-emerald-500" />} label="Emergency Line" value={data.documents?.emergencyContact1?.phone} />
//                     </div>
//                   )}
//                </div>
//             </div>

//             {/* Emergency #2 Card */}
//             <div className="bg-white rounded-2xl shadow-lg border-t-4 border-teal-500 overflow-hidden group hover:shadow-xl transition-all duration-500">
//                <div className="p-5 bg-gray-50 flex items-center justify-between border-b border-gray-100">
//                    <div className="flex items-center gap-3 text-gray-800">
//                       <div className="w-8 h-8 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center shadow-inner border border-teal-100">
//                          <FaAsterisk size={14} />
//                       </div>
//                       <h3 className="text-xs font-bold uppercase tracking-widest">Emergency #2</h3>
//                    </div>
//                    {!isEditingEmergency2 && (
//                     <button 
//                       onClick={() => setIsEditingEmergency2(true)} 
//                       className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-teal-600 border border-teal-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-teal-50 transition-all shadow-sm active:scale-95"
//                     >
//                       <FaEdit size={14} />
//                       <span>EDIT</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="p-4">
//                    {isEditingEmergency2 ? (
//                      <div className="space-y-3">
//                          <input value={emergency2Form.name} onChange={e => setEmergency2Form({...emergency2Form, name: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Name" />
//                          <input value={emergency2Form.phone} onChange={e => setEmergency2Form({...emergency2Form, phone: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Phone" />
//                          <div className="flex gap-2">
//                             <button onClick={() => handleSaveEmergencyContact(2)} className="flex-1 h-10 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-teal-100 active:scale-95 transition-all">Save</button>
//                             <button onClick={() => setIsEditingEmergency2(false)} className="px-6 h-10 bg-gray-50 text-gray-400 border border-gray-100 rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-gray-100 transition-all">Cancel</button>
//                          </div>
//                      </div>
//                   ) : (
//                     <div className="space-y-2">
//                        <MetaRow icon={<FaUser className="text-teal-500" />} label="Identity" value={data.documents?.emergencyContact2?.name} />
//                        <MetaRow icon={<FaBuilding className="text-teal-500" />} label="Emergency Line" value={data.documents?.emergencyContact2?.phone} />
//                     </div>
//                   )}
//                </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }








import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
  FaAsterisk, FaBriefcase, FaBuilding, FaCalendarAlt, FaCheck, FaDownload, FaEdit,
  FaEye, FaSave, FaSearch, FaShieldAlt, FaSignOutAlt, FaSpinner, FaSync, FaTimes,
  FaUser, FaUserTie
} from "react-icons/fa";
import { toast } from "react-toastify";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import "../index.css";
import "./EmployeeDashboard.css";
import "./EmployeeLeaves.css";

const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

const MetaRow = ({ label, value, icon }) => (
  <div className="flex items-start gap-3">
    {icon && <div className="mt-1 text-blue-500 scale-110">{icon}</div>}
    <div>
      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
      <p className="text-sm font-bold text-gray-800">{value || "---"}</p>
    </div>
  </div>
);

const StatusBadge = ({ status, className = "" }) => {
  const badges = {
    approved: "bg-emerald-50 text-emerald-700 border-emerald-100 shadow-sm",
    rejected: "bg-rose-50 text-rose-700 border-rose-100 shadow-sm",
    uploaded: "bg-blue-50 text-blue-700 border-blue-100 shadow-sm",
    missing: "bg-gray-50 text-gray-400 border-gray-100 shadow-sm"
  };

  return (
    <span className={`inline-flex items-center px-3 py-1.5 rounded-lg text-[9px] font-bold uppercase tracking-widest border transition-all duration-300 ${badges[status] || badges.missing} ${className}`}>
      {status === 'approved' && <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-2 shadow-[0_0_8px_rgba(16,185,129,0.5)]"></div>}
      {status === 'rejected' && <div className="w-1.5 h-1.5 bg-rose-500 rounded-full mr-2 shadow-[0_0_8px_rgba(244,63,94,0.5)]"></div>}
      {status === 'uploaded' && <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2 shadow-[0_0_8px_rgba(59,130,246,0.5)]"></div>}
      {status === 'missing' && <div className="w-1.5 h-1.5 bg-gray-300 rounded-full mr-2"></div>}
      {status}
    </span>
  );
};


const DocumentCard = ({ row, openFile, mark, marks, handleBulkDownload, isDownloadingBulk }) => {
  const docs = row.documents || {};
  const candidateObj = row.candidateId && typeof row.candidateId === 'object' ? row.candidateId : null;
  const candName = candidateObj?.name || row.candidateName || row.name || 'Unknown';
  const candEmail = candidateObj?.email || row.email || '';
  const candId = candidateObj?._id || candidateObj?.id || row.candidateId || row._id || '-';

  const docTypes = [
    { key: 'aadharCard', label: 'Aadhar' },
    { key: 'panCard', label: 'PAN' },
    { key: 'passportPhoto', label: 'Photo' },
    { key: 'tenthCertificate', label: '10th' },
    { key: 'twelfthCertificate', label: '12th' },
    { key: 'graduationCertificate', label: 'Grad' },
    { key: 'experienceLetters', label: 'Exp' }
  ];

  const hasBank = !!docs.bankDetails?.bankName;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-3 shadow-sm hover:shadow-md transition-shadow">
      {/* Header */}
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center text-white text-sm font-bold shadow-sm flex-shrink-0">
            {candName.charAt(0)}
          </div>
          <div>
            <h3 className="font-bold text-gray-900 text-sm">{candName}</h3>
            <p className="text-xs text-gray-400">{candEmail || String(candId).slice(-8)}</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => window.location.assign(`/personal-documents?userId=${candId}`)}
            className="text-blue-500 hover:text-blue-700 p-1"
            title="Review Documents"
          >
            <FaEye size={16} />
          </button>
          <button
            onClick={() => handleBulkDownload(row)}
            disabled={isDownloadingBulk}
            className="text-emerald-500 hover:text-emerald-700 disabled:opacity-50 p-1"
            title="Download All"
          >
            <FaDownload size={16} />
          </button>
        </div>
      </div>

      {/* Documents Grid */}
      <div className="grid grid-cols-2 gap-2">
        {docTypes.map(({ key, label }) => {
          const doc = docs[key] || {};
          const uploaded = !!doc.filePath;
          return (
            <div key={key} className="bg-gray-50 p-2 rounded-lg">
              <div className="flex items-center justify-between">
                <span className="text-[10px] font-bold text-gray-400 uppercase">{label}</span>
                {uploaded ? (
                  <div className="flex gap-1">
                    <button
                      onClick={() => openFile(doc.filePath)}
                      className="text-blue-500 hover:text-blue-700"
                      title="View"
                    >
                      <FaEye size={12} />
                    </button>
                    <button
                      onClick={() => openFile(doc.filePath)}
                      className="text-gray-400 hover:text-gray-700"
                      title="Download"
                    >
                      <FaDownload size={12} />
                    </button>
                  </div>
                ) : (
                  <FaTimes className="text-gray-200" size={12} />
                )}
              </div>
            </div>
          );
        })}
        {/* Bank Indicator */}
        <div className="bg-gray-50 p-2 rounded-lg">
          <div className="flex items-center justify-between">
            <span className="text-[10px] font-bold text-gray-400 uppercase">Bank</span>
            <div className={`w-2.5 h-2.5 rounded-full ${hasBank ? 'bg-emerald-500' : 'bg-gray-200'}`}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function PersonalDocuments() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [roles, setRoles] = useState([]);
  const [roleSearchQuery, setRoleSearchQuery] = useState("");
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const roleDropdownRef = useRef(null);

  const [marks, setMarks] = useState({});

  // Pagination states
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10,
  });

  // Editing states
  const [isEditingBank, setIsEditingBank] = useState(false);
  const [bankForm, setBankForm] = useState({ bankName: "", accountNumber: "", ifscCode: "" });
  const [isSavingBank, setIsSavingBank] = useState(false);

  const [isEditingEmergency1, setIsEditingEmergency1] = useState(false);
  const [emergency1Form, setEmergency1Form] = useState({ name: "", phone: "", relationship: "" });
  const [isSavingE1, setIsSavingE1] = useState(false);

  const [isEditingEmergency2, setIsEditingEmergency2] = useState(false);
  const [emergency2Form, setEmergency2Form] = useState({ name: "", phone: "", relationship: "" });
  const [isSavingE2, setIsSavingE2] = useState(false);
  const [isDownloadingBulk, setIsDownloadingBulk] = useState(false);

  // Get clientId from localStorage
  const getClientId = () => {
    return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
  };

  // Helper to get filtered data
  const getFilteredData = () => {
    if (!Array.isArray(data)) return [];

    return data.filter(row => {
      const docs = row.documents || {};
      const hasUploadedDocs = Object.entries(docs).some(([key, doc]) =>
        !['bankDetails', 'emergencyContact1', 'emergencyContact2', '_id'].includes(key) &&
        doc && typeof doc === 'object' && doc.filePath
      );

      const candidateObj = row.candidateId && typeof row.candidateId === 'object' ? row.candidateId : null;
      const candName = candidateObj?.name || row.candidateName || row.name || '';
      const candEmail = candidateObj?.email || row.email || '';
      const query = searchQuery.toLowerCase();

      const matchesSearch = candName.toLowerCase().includes(query) || candEmail.toLowerCase().includes(query);

      const matchesDate = dateFilter
        ? new Date(row.createdAt || row.updatedAt).toISOString().slice(0, 10) === dateFilter
        : true;

      const candRole = candidateObj?.jobId?.role || row.jobId?.role || row.role || "";
      const matchesRole = roleFilter ? candRole === roleFilter : true;

      return matchesSearch && hasUploadedDocs && matchesDate && matchesRole;
    });
  };

  useEffect(() => {
    fetchData();
    fetchRoles();

    const handleClickOutside = (event) => {
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
        setIsRoleDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update pagination when filtered data changes
  useEffect(() => {
    if (Array.isArray(data)) {
      const filtered = getFilteredData();
      setPagination(prev => ({
        ...prev,
        totalCount: filtered.length,
        totalPages: Math.ceil(filtered.length / prev.limit),
        currentPage: 1
      }));
    }
  }, [data, searchQuery, roleFilter, dateFilter]);

  const fetchRoles = async () => {
    try {
      const clientId = getClientId();
      const res = await axios.get(`${API_BASE_URL}/jobs/all/${clientId}`);
      if (res.data.success) {
        const jobData = res.data.jobPosts || res.data.data || [];
        const roleNames = Array.from(new Set(jobData.map(job => job.role))).filter(Boolean);
        const uniqueRoles = roleNames.map((name, index) => ({ _id: index, name }));
        setRoles(uniqueRoles);
      }
    } catch (err) {
      console.error("Failed to fetch roles:", err);
    }
  };

  const getQueryUserId = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("userId");
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const clientId = getClientId();
      const userId = getQueryUserId();
      const token = localStorage.getItem("candidateToken");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      if (userId) {
        // Fetch single candidate documents
        const res = await axios.get(`${API_BASE_URL}/candidate/admin/${userId}?clientId=${clientId}`, { headers });
        if (res.data) {
          const payload = res.data.success ? res.data.data : res.data;
          setData(payload);
        }
      } else {
        // Fetch all candidates documents - NEW API: /candidate/all-documents/:clientId
        const res = await axios.get(`${API_BASE_URL}/candidate/all-documents/${clientId}`, { headers });
        if (res.data && res.data.success && Array.isArray(res.data.data)) {
          setData(res.data.data);
        } else if (res.data && Array.isArray(res.data)) {
          setData(res.data);
        } else {
          setData([]);
        }
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to load documents");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // Initialize forms when data is loaded
  useEffect(() => {
    if (data && !Array.isArray(data)) {
      setBankForm({
        bankName: data.documents?.bankDetails?.bankName || "",
        accountNumber: data.documents?.bankDetails?.accountNumber || "",
        ifscCode: data.documents?.bankDetails?.ifscCode || ""
      });
      setEmergency1Form({
        name: data.documents?.emergencyContact1?.name || "",
        phone: data.documents?.emergencyContact1?.phone || "",
        relationship: data.documents?.emergencyContact1?.relationship || ""
      });
      setEmergency2Form({
        name: data.documents?.emergencyContact2?.name || "",
        phone: data.documents?.emergencyContact2?.phone || "",
        relationship: data.documents?.emergencyContact2?.relationship || ""
      });
    }
  }, [data]);

  const handleSaveBankDetails = async () => {
    if (!bankForm.bankName || !bankForm.accountNumber || !bankForm.ifscCode) {
      return toast.warning("Please fill all bank details");
    }
    setIsSavingBank(true);
    try {
      const token = localStorage.getItem("candidateToken");
      const clientId = getClientId();
      const res = await axios.post(`${API_BASE_URL}/candidate/save-bank-details`,
        { bankDetails: bankForm, clientId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        toast.success("Bank details updated");
        setIsEditingBank(false);
        fetchData();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save bank details");
    } finally {
      setIsSavingBank(false);
    }
  };

  const handleSaveEmergencyContact = async (num) => {
    const form = num === 1 ? emergency1Form : emergency2Form;
    if (!form.name || !form.phone || !form.relationship) {
      return toast.warning(`Please fill all fields for Emergency Contact #${num}`);
    }
    num === 1 ? setIsSavingE1(true) : setIsSavingE2(true);
    try {
      const token = localStorage.getItem("candidateToken");
      const clientId = getClientId();
      const res = await axios.post(`${API_BASE_URL}/candidate/save-emergency-contact`,
        { contactNumber: num, contact: form, clientId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        toast.success(`Emergency Contact #${num} updated`);
        num === 1 ? setIsEditingEmergency1(false) : setIsEditingEmergency2(false);
        fetchData();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save contact");
    } finally {
      num === 1 ? setIsSavingE1(false) : setIsSavingE2(false);
    }
  };

  const openFile = (filePath) => {
    if (!filePath) return;
    // If it's already a full URL
    if (filePath.startsWith('http')) {
      window.open(filePath, "_blank");
      return;
    }
    const baseUrl = API_BASE_URL.replace("/api", "");
    const relativePath = filePath.includes("uploads")
      ? "uploads/" + filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
      : filePath.replace(/\\/g, "/");
    const url = `${baseUrl}/${relativePath}`;
    window.open(url, "_blank");
  };

  const mark = (key, state) => {
    setMarks((s) => ({ ...s, [key]: state }));
    toast.success(`${state === "approved" ? "Approved" : "Rejected"}: ${key}`);
  };

  const handleBulkDownload = async (targetData = null) => {
    const activeData = targetData || data;
    if (!activeData || Array.isArray(activeData)) return;

    const docsToDownload = Object.entries(activeData.documents || {})
      .filter(([key, doc]) =>
        !['bankDetails', 'emergencyContact1', 'emergencyContact2', '_id'].includes(key) &&
        doc && typeof doc === 'object' && doc.filePath
      );

    if (docsToDownload.length === 0) {
      return toast.info("No documents uploaded to download");
    }

    setIsDownloadingBulk(true);
    const zip = new JSZip();
    const toastId = toast.loading(`Preparing bulk download for ${activeData.candidateName || 'Candidate'}...`);

    try {
      const baseUrl = API_BASE_URL.replace("/api", "");
      const downloadPromises = docsToDownload.map(async ([key, doc]) => {
        let url;
        if (doc.filePath.startsWith('http')) {
          url = doc.filePath;
        } else {
          const relativePath = doc.filePath.includes("uploads")
            ? "uploads/" + doc.filePath.split(/uploads[\\/]/).pop().replace(/\\/g, "/")
            : doc.filePath.replace(/\\/g, "/");
          url = `${baseUrl}/${relativePath}`;
        }

        try {
          const response = await axios.get(url, { responseType: 'arraybuffer' });
          const fileName = doc.fileName || `${key}.${doc.filePath.split('.').pop()}`;
          zip.file(fileName, response.data);
        } catch (err) {
          console.error(`Failed to download ${key}:`, err);
        }
      });

      await Promise.all(downloadPromises);

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${activeData.candidateName || 'Candidate'}_Documents.zip`);
      toast.update(toastId, { render: "Bulk download complete!", type: "success", isLoading: false, autoClose: 3000 });
    } catch (err) {
      console.error("Bulk download failed:", err);
      toast.update(toastId, { render: "Bulk download failed", type: "error", isLoading: false, autoClose: 3000 });
    } finally {
      setIsDownloadingBulk(false);
    }
  };

  // Pagination Handlers
  const handleItemsPerPageChange = (limit) => {
    const filtered = Array.isArray(data) ? getFilteredData() : [];
    setPagination({
      currentPage: 1,
      limit: limit,
      totalCount: filtered.length,
      totalPages: Math.ceil(filtered.length / limit)
    });
  };

  const handlePrevPage = () => {
    if (pagination.currentPage > 1) {
      setPagination(prev => ({
        ...prev,
        currentPage: prev.currentPage - 1
      }));
    }
  };

  const handleNextPage = () => {
    if (pagination.currentPage < pagination.totalPages) {
      setPagination(prev => ({
        ...prev,
        currentPage: prev.currentPage + 1
      }));
    }
  };

  const handlePageClick = (page) => {
    setPagination(prev => ({
      ...prev,
      currentPage: page
    }));
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= pagination.totalPages; i++) {
      if (
        i === 1 ||
        i === pagination.totalPages ||
        (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)
      ) {
        pageNumbers.push(i);
      } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
        pageNumbers.push("...");
      }
    }
    return pageNumbers;
  };

  const resetFilters = () => {
    setSearchQuery("");
    setRoleFilter("");
    setDateFilter("");
    setRoleSearchQuery("");
  };

  if (loading)
    return (
      <div className="admin-dash">
        <div className="admin-dash__loading">
          <div className="admin-dash__spinner" />
          <p className="admin-dash__loading-text">Loading documents…</p>
        </div>
      </div>
    );

  if (Array.isArray(data) && data.length === 0 && !loading) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="bg-white rounded-lg p-8 shadow-md text-center max-w-sm w-full border border-gray-100">
        <FaUser size={32} className="mx-auto text-gray-300 mb-4" />
        <h2 className="text-xl font-bold text-gray-800 mb-2">No Documents Found</h2>
        <p className="text-sm text-gray-500 mb-6">No candidate documents available.</p>
        <button onClick={fetchData} className="w-full py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors">Retry</button>
      </div>
    </div>
  );

  if (!data && !loading) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="bg-white rounded-lg p-8 shadow-md text-center max-w-sm w-full border border-gray-100">
        <FaUser size={32} className="mx-auto text-gray-300 mb-4" />
        <h2 className="text-xl font-bold text-gray-800 mb-2">Unavailable</h2>
        <p className="text-sm text-gray-500 mb-6">Candidate profile not found.</p>
        <button onClick={fetchData} className="w-full py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors">Retry</button>
      </div>
    </div>
  );

  // Admin List View
  if (Array.isArray(data)) {
    const filteredData = getFilteredData();

    const indexOfLastItem = pagination.currentPage * pagination.limit;
    const indexOfFirstItem = indexOfLastItem - pagination.limit;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    return (
      <div style={{backgroundColor:'white'}} className="emp-dash">
        <main className="">

          {/* Dashboard Header */}
          <div className="emp-dash__header">
            <div>
              <h1 className="emp-dash__greeting">
                Personal <span>Documents</span>
              </h1>
              <p className="emp-dash__subtitle">
                Review and manage candidate personal documents.
              </p>
            </div>
            <div className="emp-dash__date-pill">
              <FaShieldAlt />
              <span>
                {new Date().toLocaleDateString("en-US", {
                  weekday: "short",
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </span>
            </div>
          </div>

          {/* Filters Section */}
          <div className="emp-dash__card mb-6">
            <div className="emp-dash__card-header">
              <div>
                <h3 className="emp-dash__card-title flex items-center gap-2">
                  <FaSearch className="text-blue-600" /> Filter Documents
                </h3>
                <p className="emp-dash__card-desc">Search by name, email or role</p>
              </div>
            </div>
            <div className="emp-dash__card-body bg-gray-50/50">
              <div className="flex flex-wrap items-center gap-2">

                {/* Search Bar */}
                <div className="relative flex-1 min-w-[180px]">
                  <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                  <input
                    type="text"
                    placeholder="Search by name or email..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                {/* Role Filter Button */}
                <div className="relative" ref={roleDropdownRef}>
                  <button
                    onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
                    className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                      roleFilter
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                    }`}
                  >
                    <FaBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
                  </button>

                  {/* Role Filter Dropdown */}
                  {isRoleDropdownOpen && (
                    <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                      <div className="p-2 border-b border-gray-100 bg-gray-50">
                        <div className="relative">
                          <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                          <input
                            type="text"
                            className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            placeholder="Search roles..."
                            value={roleSearchQuery}
                            onChange={(e) => setRoleSearchQuery(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                          />
                        </div>
                      </div>
                      <div
                        onClick={() => { setRoleFilter(''); setIsRoleDropdownOpen(false); setRoleSearchQuery(''); }}
                        className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
                          !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                        }`}
                      >
                        All Roles
                      </div>
                      {roles
                        .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                        .map((r) => (
                          <div
                            key={r._id}
                            onClick={() => { setRoleFilter(r.name); setIsRoleDropdownOpen(false); setRoleSearchQuery(''); }}
                            className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
                              roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                            }`}
                          >
                            {r.name}
                          </div>
                        ))}
                      {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                        <div className="px-3 py-2 text-xs text-gray-400 text-center">No roles found</div>
                      )}
                    </div>
                  )}
                </div>

                {/* Date Filter */}
                <div className="relative">
                  <button
                    onClick={(e) => {
                      const dateInput = e.currentTarget.nextElementSibling;
                      if (dateInput && dateInput.showPicker) {
                        dateInput.showPicker();
                      } else {
                        dateInput?.focus();
                      }
                    }}
                    className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                      dateFilter
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
                    }`}
                  >
                    <FaCalendarAlt className="text-xs" /> {dateFilter ? new Date(dateFilter).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Date'}
                  </button>
                  <input
                    type="date"
                    value={dateFilter}
                    onChange={(e) => setDateFilter(e.target.value)}
                    className="absolute opacity-0 pointer-events-none"
                    style={{ width: 0, height: 0 }}
                  />
                </div>

                {/* Refresh Button */}
                <button
                  onClick={fetchData}
                  className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition flex items-center gap-1"
                  title="Refresh"
                >
                  <FaSync className={loading ? 'animate-spin' : ''} size={11} />
                </button>

                {/* Clear Filters Button */}
                {(searchQuery || roleFilter || dateFilter) && (
                  <button
                    onClick={resetFilters}
                    className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
                  >
                    Clear
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Documents List */}
          <div className="emp-dash__card mb-6">
            {loading ? (
              <div className="py-10 text-center">
                <div className="flex flex-col items-center justify-center gap-3">
                  <div className="emp-dash__spinner"></div>
                  <span className="text-sm font-medium text-gray-500">Loading documents...</span>
                </div>
              </div>
            ) : filteredData.length > 0 ? (
              <>
                {/* Desktop Table - Hidden on mobile */}
                <div className="hidden md:block emp-dash__table-wrap overflow-x-auto w-full">
                  <table className="emp-dash__table min-w-[800px] w-full">
                    <thead>
                      <tr>
                        <th>Candidate</th>
                        {["Aadhar", "PAN", "Photo", "10th", "12th", "Grad", "Exp", "Bank"].map(h => (
                          <th key={h}>{h}</th>
                        ))}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((row) => {
                        const docs = row.documents || {};
                        const candidateObj = row.candidateId && typeof row.candidateId === 'object' ? row.candidateId : null;
                        const candName = candidateObj?.name || row.candidateName || row.name || 'Unknown';
                        const candEmail = candidateObj?.email || row.email || '';
                        const candId = candidateObj?._id || candidateObj?.id || row.candidateId || row._id || '-';

                        const renderDocMini = (docKey) => {
                          const doc = docs[docKey] || {};
                          const uploaded = !!doc.filePath;
                          return (
                            <td key={docKey} className="px-2 py-2 text-center">
                              <div className="flex items-center justify-center gap-1">
                                {uploaded ? (
                                  <>
                                    <button
                                      onClick={() => openFile(doc.filePath)}
                                      className="text-blue-500 hover:text-blue-700"
                                      title="View"
                                    >
                                      <FaEye size={13} />
                                    </button>
                                    <button
                                      onClick={() => openFile(doc.filePath)}
                                      className="text-gray-400 hover:text-gray-700"
                                      title="Download"
                                    >
                                      <FaDownload size={13} />
                                    </button>
                                  </>
                                ) : (
                                  <FaTimes className="text-gray-200 mx-auto" size={11} />
                                )}
                              </div>
                            </td>
                          );
                        };

                        return (
                          <tr key={candId} className="border-b hover:bg-gray-50 transition-colors">
                            <td className="px-2 py-2">
                              <div className="flex items-center gap-2">
                                <div className="w-7 h-7 rounded-full bg-gradient-to-br from-purple-500 to-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm flex-shrink-0">
                                  {candName.charAt(0)}
                                </div>
                                <div className="text-left">
                                  <div className="text-gray-900 whitespace-nowrap text-xs font-medium">{candName}</div>
                                  <div className="text-[10px] text-gray-400">{candEmail || String(candId).slice(-8)}</div>
                                </div>
                              </div>
                            </td>
                            {renderDocMini('aadharCard')}
                            {renderDocMini('panCard')}
                            {renderDocMini('passportPhoto')}
                            {renderDocMini('tenthCertificate')}
                            {renderDocMini('twelfthCertificate')}
                            {renderDocMini('graduationCertificate')}
                            {renderDocMini('experienceLetters')}
                            <td className="px-2 py-2 text-center">
                              <div className={`w-2 h-2 mx-auto rounded-full ${docs.bankDetails?.bankName ? 'bg-emerald-500' : 'bg-gray-200'}`}></div>
                            </td>
                            <td className="px-2 py-2 text-center">
                              <div className="flex justify-center gap-2">
                                <button
                                  onClick={() => window.location.assign(`/personal-documents?userId=${candId}`)}
                                  className="text-blue-500 hover:text-blue-700"
                                  title="Review Documents"
                                >
                                  <FaEye size={14} />
                                </button>
                                <button
                                  onClick={() => handleBulkDownload(row)}
                                  disabled={isDownloadingBulk}
                                  className="text-emerald-500 hover:text-emerald-700 disabled:opacity-50"
                                  title="Download All"
                                >
                                  <FaDownload size={14} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Cards - Visible on mobile only */}
                <div className="md:hidden p-4">
                  {currentItems.map((row) => (
                    <DocumentCard 
                      key={row._id || row.candidateId} 
                      row={row} 
                      openFile={openFile} 
                      mark={mark} 
                      marks={marks} 
                      handleBulkDownload={handleBulkDownload} 
                      isDownloadingBulk={isDownloadingBulk}
                    />
                  ))}
                </div>

                {/* Pagination */}
                {filteredData.length > 0 && (
                  <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
                    {/* Left Side - Showing Info + Select */}
                    <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                      <span>Showing</span>
                      <span className="font-medium">{indexOfFirstItem + 1}</span>
                      <span>to</span>
                      <span className="font-medium">{Math.min(indexOfLastItem, filteredData.length)}</span>
                      <span>of</span>
                      <span className="font-medium">{filteredData.length}</span>
                      <span>results</span>
                      <select
                        value={pagination.limit}
                        onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                        className="p-1 ml-2 text-sm border rounded-lg"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>
                    </div>

                    {/* Pagination buttons */}
                    <div className="flex items-center gap-2 mt-2 sm:mt-0">
                      <button
                        onClick={handlePrevPage}
                        disabled={pagination.currentPage === 1}
                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                          pagination.currentPage === 1
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        Previous
                      </button>

                      <div className="flex items-center gap-1">
                        {getPageNumbers().map((page, index) => (
                          <button
                            key={index}
                            onClick={() => typeof page === 'number' ? handlePageClick(page) : null}
                            disabled={page === "..."}
                            className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                              page === "..."
                                ? "text-gray-500 cursor-default"
                                : pagination.currentPage === page
                                ? "bg-blue-600 text-white"
                                : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"
                            }`}
                          >
                            {page}
                          </button>
                        ))}
                      </div>

                      <button
                        onClick={handleNextPage}
                        disabled={pagination.currentPage === pagination.totalPages}
                        className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
                          pagination.currentPage === pagination.totalPages
                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                        }`}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-20">
                <div className="bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <FaSearch className="text-2xl text-gray-200" />
                </div>
                <h2 className="text-lg font-bold text-gray-800">No records found</h2>
                <p className="text-xs text-gray-400 mt-1">Try refined search parameters</p>
              </div>
            )}
          </div>

        </main>
      </div>
    );
  }

  // Profile Specific View (single candidate)
  const docKeys = Object.keys(data.documents || {}).filter(key =>
    !['bankDetails', 'emergencyContact1', 'emergencyContact2', '_id'].includes(key)
  );

  return (
    <div className="w-full min-h-screen p-2 sm:p-4 bg-slate-50/50">
      <div className="max-w-[1600px] mx-auto space-y-3">
        
        {/* Corporate Sleek Header */}
        <div className="relative overflow-hidden bg-gradient-to-r from-green-600 to-blue-700 rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-xl border border-white/10 group">
          <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent"></div>
          
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
            <div className="flex items-center gap-3 sm:gap-5 w-full md:w-auto">
              <div className="relative flex-shrink-0">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center text-blue-600 text-xl sm:text-2xl font-bold shadow-2xl ring-4 ring-white/20 group-hover:scale-105 transition-transform duration-500 bg-white">
                  {data.candidateName?.charAt(0) || data.candidateId?.name?.charAt(0) || <FaUser />}
                </div>
                <div className="absolute -bottom-1 -right-1 w-5 h-5 sm:w-6 sm:h-6 bg-emerald-500 rounded-lg border-2 border-white flex items-center justify-center text-white shadow-lg">
                  <FaCheck size={10} />
                </div>
              </div>
              
              <div className="text-center md:text-left flex-1 min-w-0">
                <h1 className="text-base sm:text-xl font-bold text-white tracking-tight drop-shadow-sm truncate">
                  {data.candidateName || data.candidateId?.name || 'Review Profile'}
                </h1>
                <p className="text-white/90 text-[8px] sm:text-[9px] font-bold uppercase tracking-[0.15em] mt-1.5 flex items-center justify-center md:justify-start gap-1.5 bg-white/10 backdrop-blur-md px-2.5 py-0.5 rounded-lg w-fit border border-white/10">
                  <FaUserTie size={10} className="text-emerald-400" /> IDENTITY VERIFICATION RECORD
                </p>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-1 sm:gap-2 mt-2 sm:mt-3">
                  <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-white/10 backdrop-blur-md text-blue-100 text-[8px] sm:text-[9px] font-bold uppercase tracking-wider rounded-lg border border-white/10">
                    UID: {data._id?.slice(-8).toUpperCase()}
                  </span>
                  <span className="px-2 sm:px-3 py-0.5 sm:py-1 bg-white/10 backdrop-blur-md text-emerald-100 text-[8px] sm:text-[9px] font-bold uppercase tracking-wider rounded-lg border border-white/10 flex items-center gap-1.5">
                    <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></div>
                    VERIFIED
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 w-full md:w-auto">
              <button
                onClick={() => handleBulkDownload()}
                disabled={isDownloadingBulk}
                className="h-9 sm:h-10 px-4 sm:px-6 bg-white/20 hover:bg-white text-white hover:text-blue-600 rounded-xl font-bold text-[9px] sm:text-[10px] uppercase tracking-widest flex items-center gap-2 sm:gap-3 transition-all border border-white/10 active:scale-95 disabled:opacity-50"
              >
                {isDownloadingBulk ? <FaSpinner className="animate-spin" size={12} /> : <FaDownload size={12} />}
                <span className="hidden xs:inline">{isDownloadingBulk ? "GENERATING..." : "DOWNLOAD VAULT"}</span>
                <span className="xs:hidden">{isDownloadingBulk ? "..." : "DL"}</span>
              </button>
              <button
                onClick={() => window.location.assign('/personal-documents')}
                className="h-9 sm:h-10 px-4 sm:px-6 bg-white text-blue-600 hover:bg-gray-50 rounded-xl font-bold text-[9px] sm:text-[10px] uppercase tracking-widest shadow-xl transition-all active:scale-95 flex items-center gap-2 sm:gap-3"
              >
                <FaSignOutAlt size={12} />
                <span className="hidden xs:inline">BACK TO INDEX</span>
                <span className="xs:hidden">BACK</span>
              </button>
            </div>
          </div>
        </div>

        {/* Main Review Dashboard */}
        <div className="flex flex-col gap-3 pb-8">
          
          {/* Documents Table View */}
          <div className="w-full space-y-3">
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="p-3 sm:p-4 bg-gray-50/50 border-b border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shadow-inner border border-blue-100">
                    <FaBriefcase size={14} />
                  </div>
                  <h3 className="text-xs font-bold text-gray-800 uppercase tracking-widest font-sans">Primary Credentials</h3>
                </div>
                <div className="flex flex-wrap items-center gap-2 sm:gap-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest bg-white px-3 sm:px-4 py-1.5 rounded-full border border-gray-100">
                  <div className="flex items-center gap-1">
                    <div className="w-2 h-2 bg-emerald-500 rounded-full"></div> 
                    <span className="hidden xs:inline">Approved</span>
                    <span className="xs:hidden">App</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div> 
                    <span className="hidden xs:inline">Uploaded</span>
                    <span className="xs:hidden">Up</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <div className="w-2 h-2 bg-gray-300 rounded-full"></div> 
                    <span className="hidden xs:inline">Missing</span>
                    <span className="xs:hidden">Miss</span>
                  </div>
                </div>
              </div>

              {/* Desktop Table - Hidden on mobile */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full text-left">
                  <thead className="bg-gradient-to-r from-green-500 to-blue-600 text-[11px] font-bold text-white uppercase tracking-widest border-b border-blue-100">
                    <tr>
                      <th className="px-6 py-5">Asset Identification</th>
                      <th className="px-6 py-5 text-center">Status</th>
                      <th className="px-6 py-5 text-center">Reference</th>
                      <th className="px-6 py-5 text-right">Verification Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50 border-t border-gray-100">
                    {docKeys.map((key) => {
                      const doc = data.documents[key] || {};
                      const uploaded = !!doc.filePath;
                      const state = marks[key] || (doc.verified ? 'approved' : uploaded ? 'uploaded' : 'missing');

                      return (
                        <tr key={key} className="group hover:bg-slate-50 transition-all duration-300">
                          <td className="px-6 py-4">
                            <div className="flex items-center gap-4">
                              <div className={`w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-500 ${uploaded ? 'bg-blue-50 text-blue-600 shadow-inner group-hover:bg-blue-600 group-hover:text-white' : 'bg-gray-50 text-gray-300 border border-gray-100'}`}>
                                <FaBriefcase size={18} />
                              </div>
                              <div>
                                <p className="text-xs font-bold text-gray-900 uppercase tracking-tight group-hover:text-blue-600 transition-colors">{key.replace(/([A-Z])/g, ' $1')}</p>
                                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">{uploaded ? 'Synchronized Archive' : 'Awaiting Manifest'}</p>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-center">
                            <StatusBadge status={state} />
                          </td>
                          <td className="px-6 py-4 text-center font-mono text-[10px] text-gray-400 font-bold uppercase tracking-tighter">
                            {doc.fileName ? `...${doc.fileName.slice(-15)}` : '--'}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center justify-end gap-2 outline-none">
                              <button
                                onClick={() => openFile(doc.filePath)}
                                disabled={!uploaded}
                                className={`h-11 px-5 rounded-xl transition-all flex items-center gap-2 active:scale-95 ${uploaded ? 'bg-gradient-to-r from-green-500 to-blue-600 text-white hover:from-green-600 hover:to-blue-700 shadow-md shadow-blue-100' : 'bg-gray-100 text-gray-400 cursor-not-allowed opacity-50'}`}
                              >
                                <FaEye size={18} />
                                <span className="text-[11px] font-bold uppercase tracking-widest">{uploaded ? '' : 'Locked'}</span>
                              </button>
                              <div className="h-6 w-px bg-gray-200 mx-1"></div>
                              <button
                                onClick={() => mark(key, 'approved')}
                                className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all border-2 ${state === 'approved' ? 'bg-emerald-500 border-emerald-500 text-white shadow-lg shadow-emerald-200' : 'border-emerald-100 bg-emerald-50 text-emerald-600 hover:bg-emerald-500 hover:text-white hover:border-emerald-500 shadow-sm'}`}
                                title="Approve"
                              >
                                <FaCheck size={24} />
                              </button>
                              <button
                                onClick={() => mark(key, 'rejected')}
                                className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all border-2 ${state === 'rejected' ? 'bg-rose-500 border-rose-500 text-white shadow-lg shadow-rose-200' : 'border-rose-100 bg-rose-50 text-rose-600 hover:bg-rose-500 hover:text-white hover:border-rose-500 shadow-sm'}`}
                                title="Reject"
                              >
                                <FaTimes size={24} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile Cards for Single Candidate View */}
              <div className="md:hidden p-4 space-y-3">
                {docKeys.map((key) => {
                  const doc = data.documents[key] || {};
                  const uploaded = !!doc.filePath;
                  const state = marks[key] || (doc.verified ? 'approved' : uploaded ? 'uploaded' : 'missing');

                  return (
                    <div key={key} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex items-center gap-3">
                          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${uploaded ? 'bg-blue-50 text-blue-600' : 'bg-gray-100 text-gray-300'}`}>
                            <FaBriefcase size={16} />
                          </div>
                          <div>
                            <p className="text-xs font-bold text-gray-900 uppercase tracking-tight">{key.replace(/([A-Z])/g, ' $1')}</p>
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">{uploaded ? 'Uploaded' : 'Missing'}</p>
                          </div>
                        </div>
                        <StatusBadge status={state} />
                      </div>

                      <div className="flex items-center justify-between gap-2">
                        <div className="text-[10px] text-gray-400 font-mono truncate flex-1">
                          {doc.fileName ? `📄 ${doc.fileName}` : 'No file'}
                        </div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => openFile(doc.filePath)}
                            disabled={!uploaded}
                            className={`p-2 rounded-xl transition-all ${uploaded ? 'bg-gradient-to-r from-green-500 to-blue-600 text-white hover:shadow-lg' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}
                          >
                            <FaEye size={14} />
                          </button>
                          <button
                            onClick={() => mark(key, 'approved')}
                            className={`p-2 rounded-xl transition-all border-2 ${state === 'approved' ? 'bg-emerald-500 border-emerald-500 text-white' : 'border-emerald-200 bg-emerald-50 text-emerald-600'}`}
                          >
                            <FaCheck size={14} />
                          </button>
                          <button
                            onClick={() => mark(key, 'rejected')}
                            className={`p-2 rounded-xl transition-all border-2 ${state === 'rejected' ? 'bg-rose-500 border-rose-500 text-white' : 'border-rose-200 bg-rose-50 text-rose-600'}`}
                          >
                            <FaTimes size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Details Row - Three Cards Side by Side */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            
            {/* Bank Card */}
            <div className="bg-white rounded-2xl shadow-lg border-t-4 border-blue-500 overflow-hidden group hover:shadow-xl transition-all duration-500">
              <div className="p-4 sm:p-5 bg-gray-50 flex items-center justify-between border-b border-gray-100">
                <div className="flex items-center gap-3 text-gray-800">
                  <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shadow-inner border border-blue-100">
                    <FaBuilding size={14} />
                  </div>
                  <h3 className="text-xs font-bold uppercase tracking-widest">Banking Profile</h3>
                </div>
                {!isEditingBank && (
                  <button 
                    onClick={() => setIsEditingBank(true)} 
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-blue-600 border border-blue-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-blue-50 transition-all shadow-sm active:scale-95"
                  >
                    <FaEdit size={14} />
                    <span className="hidden xs:inline">EDIT</span>
                    <span className="xs:hidden">✎</span>
                  </button>
                )}
              </div>
              
              <div className="p-3 sm:p-4 space-y-3">
                {isEditingBank ? (
                  <div className="space-y-3">
                    <input value={bankForm.bankName} onChange={e => setBankForm({...bankForm, bankName: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none focus:ring-1 focus:ring-blue-500" placeholder="Bank Name" />
                    <input value={bankForm.accountNumber} onChange={e => setBankForm({...bankForm, accountNumber: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold font-mono outline-none focus:ring-1 focus:ring-blue-500" placeholder="A/C Number" />
                    <div className="flex gap-2">
                      <button onClick={handleSaveBankDetails} className="flex-1 h-10 bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-blue-100 active:scale-95 transition-all">Save</button>
                      <button onClick={() => setIsEditingBank(false)} className="px-6 h-10 bg-gray-50 text-gray-400 border border-gray-100 rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-gray-100 transition-all">Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    <MetaRow icon={<FaBuilding className="text-blue-500" />} label="Financial Institution" value={data.documents?.bankDetails?.bankName} />
                    <MetaRow icon={<FaBuilding className="text-blue-500" />} label="Account Repository" value={data.documents?.bankDetails?.accountNumber} />
                    <MetaRow icon={<FaBuilding className="text-blue-500" />} label="Transit Code (IFSC)" value={data.documents?.bankDetails?.ifscCode} />
                  </div>
                )}
              </div>
            </div>

            {/* Emergency #1 Card */}
            <div className="bg-white rounded-2xl shadow-lg border-t-4 border-emerald-500 overflow-hidden group hover:shadow-xl transition-all duration-500">
              <div className="p-4 sm:p-5 bg-gray-50 flex items-center justify-between border-b border-gray-100">
                <div className="flex items-center gap-3 text-gray-800">
                  <div className="w-8 h-8 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-inner border border-emerald-100">
                    <FaAsterisk size={14} />
                  </div>
                  <h3 className="text-xs font-bold uppercase tracking-widest">Emergency #1</h3>
                </div>
                {!isEditingEmergency1 && (
                  <button 
                    onClick={() => setIsEditingEmergency1(true)} 
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-emerald-600 border border-emerald-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-emerald-50 transition-all shadow-sm active:scale-95"
                  >
                    <FaEdit size={14} />
                    <span className="hidden xs:inline">EDIT</span>
                    <span className="xs:hidden">✎</span>
                  </button>
                )}
              </div>
              <div className="p-3 sm:p-4">
                {isEditingEmergency1 ? (
                  <div className="space-y-3">
                    <input value={emergency1Form.name} onChange={e => setEmergency1Form({...emergency1Form, name: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Name" />
                    <input value={emergency1Form.phone} onChange={e => setEmergency1Form({...emergency1Form, phone: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Phone" />
                    <div className="flex gap-2">
                      <button onClick={() => handleSaveEmergencyContact(1)} className="flex-1 h-10 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-emerald-100 active:scale-95 transition-all">Save</button>
                      <button onClick={() => setIsEditingEmergency1(false)} className="px-6 h-10 bg-gray-50 text-gray-400 border border-gray-100 rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-gray-100 transition-all">Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    <MetaRow icon={<FaUser className="text-emerald-500" />} label="Identity" value={data.documents?.emergencyContact1?.name} />
                    <MetaRow icon={<FaBuilding className="text-emerald-500" />} label="Emergency Line" value={data.documents?.emergencyContact1?.phone} />
                  </div>
                )}
              </div>
            </div>

            {/* Emergency #2 Card */}
            <div className="bg-white rounded-2xl shadow-lg border-t-4 border-teal-500 overflow-hidden group hover:shadow-xl transition-all duration-500">
              <div className="p-4 sm:p-5 bg-gray-50 flex items-center justify-between border-b border-gray-100">
                <div className="flex items-center gap-3 text-gray-800">
                  <div className="w-8 h-8 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center shadow-inner border border-teal-100">
                    <FaAsterisk size={14} />
                  </div>
                  <h3 className="text-xs font-bold uppercase tracking-widest">Emergency #2</h3>
                </div>
                {!isEditingEmergency2 && (
                  <button 
                    onClick={() => setIsEditingEmergency2(true)} 
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-teal-600 border border-teal-100 rounded-lg text-[10px] font-bold uppercase tracking-widest hover:bg-teal-50 transition-all shadow-sm active:scale-95"
                  >
                    <FaEdit size={14} />
                    <span className="hidden xs:inline">EDIT</span>
                    <span className="xs:hidden">✎</span>
                  </button>
                )}
              </div>
              <div className="p-3 sm:p-4">
                {isEditingEmergency2 ? (
                  <div className="space-y-3">
                    <input value={emergency2Form.name} onChange={e => setEmergency2Form({...emergency2Form, name: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Name" />
                    <input value={emergency2Form.phone} onChange={e => setEmergency2Form({...emergency2Form, phone: e.target.value})} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-xs font-bold outline-none" placeholder="Phone" />
                    <div className="flex gap-2">
                      <button onClick={() => handleSaveEmergencyContact(2)} className="flex-1 h-10 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] shadow-lg shadow-teal-100 active:scale-95 transition-all">Save</button>
                      <button onClick={() => setIsEditingEmergency2(false)} className="px-6 h-10 bg-gray-50 text-gray-400 border border-gray-100 rounded-xl text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-gray-100 transition-all">Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    <MetaRow icon={<FaUser className="text-teal-500" />} label="Identity" value={data.documents?.emergencyContact2?.name} />
                    <MetaRow icon={<FaBuilding className="text-teal-500" />} label="Emergency Line" value={data.documents?.emergencyContact2?.phone} />
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
